import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

interface BlockContentProps {
  index: number;
  title: string;
}

export const BlockContent = ({ index, title }: BlockContentProps) => (
  <div className="flex flex-col items-center justify-center gap-y-3">
    <div
      className={classNames(
        "flex size-8 min-h-8 min-w-8 items-center justify-center rounded-full text-center",
        {
          "bg-secondary border-primary border": index % 2 !== 0,
          "bg-c-active-item-color": index % 2 === 0,
        },
      )}
    >
      <Typography.LabelSm
        weight="bold"
        color={classNames({
          "text-default": index % 2 !== 0,
          "text-feature-dark": index % 2 === 0,
        })}
      >
        {index}
      </Typography.LabelSm>
    </div>
    <Typography.LabelMd weight="semibold" color="text-default">
      {title}
    </Typography.LabelMd>
  </div>
);
